import { useEffect, useState } from 'react';
import { useWorkContext } from '../context/WorkContext';
import Make from '../components/MakeSection/Make';
import Focus from '../components/FocusServices/Focus';
import FAQs from '../components/FAQsSection/FAQs';
import IssueSection from '../components/IssuesSection/Issue';
import LatestArticles from '../components/LatestArticles/LatestArticles';
import RelatedServices from '../components/RelatedServicesSection/RelatedServices';
import ProjectItem from '../components/WorkProjectsList/ProjectItem/ProjectItem';
import Digital from '../components/AdSection/AdSection';
import Quote from './../components/QuoteSection/Quote';
import HeroSection from '../components/HeroSection/HeroSection';
import SEO from '../components/SEO/SEO';
import { usePageSEO } from '../hooks/usePageSEO';

const Marketing = () => {
    const seo = usePageSEO('marketing');
    const { getRandomProject } = useWorkContext();
    const [randomProject, setRandomProject] = useState(null);

    useEffect(() => {
        const project = getRandomProject();
        setRandomProject(project);
    }, [getRandomProject]);

    const selectedServiceIds = [1, 6, 7, 9];

    return (
        <>
            <SEO
                title={seo.title}
                description={seo.description}
                keywords={seo.keywords}
                type={seo.type}
                noIndex={seo.noIndex}
                noFollow={seo.noFollow}
            />
            <HeroSection page="MarketingPage" showRecentWork={false} showMoreButton={false} />
            <Digital page="MarketingPage" />
            <Quote page="MarketingPage" />
            <IssueSection page="MarketingPage" skeletonItemsCount={3} subCountSkeleton={1} />
            <Focus page="MarketingPage" />
            <FAQs page='marketingPage' />
            <RelatedServices services={selectedServiceIds} />
            <LatestArticles/>
            <ProjectItem project={randomProject} index={0} />
            <Make pageKey='marketingPage' />
        </>
    );
};

export default Marketing;